export const padLeadingZeros = (num?: number, size?: number) => {
  const numAsString = num?.toString() ?? "00";
  return numAsString.padStart(size ?? 2, "0");
};
